import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";
import type { PaymentProviderType } from "@/feature-wallet/models/payment-method-provider.mjs";

export function onProConversion(data: {
  providerType: PaymentProviderType | "BOLTS";
}) {
  return refs.trackEvent(ANALYTIC_EVENTS.PRO_CONVERSION, data);
}
